// src/components/mobile/MobileStickyHeader.tsx
import React from 'react';
import '../../styles/mobile/mobile-common.css';

interface MobileStickyHeaderProps {
  title: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode[];
  className?: string;
}

export const MobileStickyHeader: React.FC<MobileStickyHeaderProps> = ({
  title,
  icon,
  actions = [],
  className = ''
}) => {
  return (
    <div
      className={`mobile-sticky-header ${className}`}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 'var(--z-sticky)',
        height: 'var(--mobile-header)',
        backgroundColor: 'var(--panel-header-bg, var(--secondary))',
        backgroundImage: 'var(--panel-header-gradient, none)',
        color: 'var(--text-on-header, white)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 var(--space-3)',
        borderBottom: '1px solid var(--panel-header-border, rgba(0, 0, 0, 0.1))',
        boxShadow: 'var(--panel-shadow, 0 2px 4px rgba(0, 0, 0, 0.1))'
      }}
    >
      <h1
        style={{
          fontSize: 'var(--mobile-h1)',
          fontWeight: 600,
          margin: 0,
          fontFamily: "'Segoe UI', 'Noto Sans', system-ui, sans-serif",
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--space-2)',
          flex: 1,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
      >
        {icon && <span style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>{icon}</span>}
        <span>{title}</span>
      </h1>
      
      {actions.length > 0 && (
        <div style={{ display: 'flex', gap: 'var(--space-1)', flexShrink: 0 }}>
          {actions.map((action, index) => (
            <div key={index}>{action}</div>
          ))}
        </div>
      )}
    </div>
  );
};
